import { _ as t } from "../internals/export.js";
import { d as r } from "../internals/descriptors.js";
import { o as s } from "../internals/object-create.js";
t({
  target: "Object",
  stat: !0,
  sham: !r
}, {
  create: s
});